// O editor de texto rico do formulário de modelos devolve markdown, mas o corpo de um
// modelo do WhatsApp é texto puro com a formatação própria do app (*negrito*, _itálico_,
// ~tachado~). Sem a conversão, as quebras de linha chegam como "\" + enter (hard break do
// markdown) e o "\" aparece no preview e é enviado à Meta.

const BOLD_PLACEHOLDER = '\u0000';

// Caracteres escapados (\*, \_ ...) são literais. Enquanto as conversões rodam eles viram
// um caractere da área de uso privado (offset fixo) e voltam ao original no fim.
const ESCAPE_OFFSET = 0xe000;
const MARKDOWN_ESCAPE = /\\([\\`*_~{}[\]()#+\-.!>|])/g;
const ESCAPED_RANGE = /[-]/g;

// Só remove o "\" de fim de linha. Seguro para qualquer texto, inclusive o de modelos
// que já estão no formato do WhatsApp.
export const stripMarkdownHardBreaks = (text = '') =>
  (text || '').replace(/\\\r?\n/g, '\n');

export const markdownToWhatsapp = (text = '') => {
  const converted = stripMarkdownHardBreaks(text)
    .replace(MARKDOWN_ESCAPE, (_, char) =>
      String.fromCharCode(ESCAPE_OFFSET + char.charCodeAt(0))
    )
    // negrito (**x**) vira marcador para não ser confundido com o itálico (*x*)
    .replace(/\*\*(.+?)\*\*/g, `${BOLD_PLACEHOLDER}$1${BOLD_PLACEHOLDER}`)
    .replace(/(?<![*\w])\*(?!\s)(.+?)(?<!\s)\*(?![*\w])/g, '_$1_')
    .replace(/~~(.+?)~~/g, '~$1~')
    .replace(new RegExp(BOLD_PLACEHOLDER, 'g'), '*');

  return converted.replace(ESCAPED_RANGE, char =>
    String.fromCharCode(char.charCodeAt(0) - ESCAPE_OFFSET)
  );
};

const escapeHtml = text =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

// Renderiza a formatação do WhatsApp como HTML para o preview. O texto é escapado antes,
// então só as tags geradas aqui chegam ao v-html.
export const whatsappTextToHtml = (text = '') =>
  escapeHtml(text || '')
    .replace(/```([\s\S]+?)```/g, '<code>$1</code>')
    .replace(/(?<![*\w])\*(?!\s)([^*\n]+?)(?<!\s)\*(?![*\w])/g, '<b>$1</b>')
    .replace(/(?<![_\w])_(?!\s)([^_\n]+?)(?<!\s)_(?![_\w])/g, '<i>$1</i>')
    .replace(/(?<![~\w])~(?!\s)([^~\n]+?)(?<!\s)~(?![~\w])/g, '<s>$1</s>')
    .replace(/\n/g, '<br>');
